import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { useAppStateContext, AppState } from 'src/AppState/AppState';
import Loading from 'src/components/Loading';
import { action, computed, observable, makeAutoObservable } from 'mobx';
import {
    EventsCollectionQueryCompetitionWithEventsType,
    EventsCollectionQueryModel,
} from 'src_common/common/websocket2/models/EventsCollectionQueryModel';
import moment from 'moment';
import { EventsCollectionQueryType } from 'src_common/common/websocket2/modelsApi/EventsCollectionQuery';
import { AntePostCompetition } from './AntePostCompetition';
import { AutoMap } from 'src_common/common/mobx-utils/AutoMap';

interface PropsTypes {
    sport: string;
    userId: number;
}

class State {
    @observable public activeCompetitionId: number | null = null;

    public constructor(
        private readonly appState: AppState,
        private readonly sport: string
    ) {
        makeAutoObservable(this);
    }

    @computed private get query(): EventsCollectionQueryType {
        return {
            sport: [this.sport],
            'startTime[from]': moment().format('YYYY-MM-DD'),
        };
    }

    @computed public get queryModel(): EventsCollectionQueryModel | null {
        return this.appState.websocketV2.getEventQuery(this.query);
    }

    @computed public get competitionsWithAntePostEvent(): Array<EventsCollectionQueryCompetitionWithEventsType> {
        const tempCompetitionsWithAntePostEvent = [];
        const competitions = this.queryModel?.competitionsRaw ?? [];
        for (const competition of competitions) {
            const events = competition.events.filter((elem) => {
                const eventModel = this.appState.websocketV2.getEvent(elem.id);
                if (eventModel !== null) {
                    const markets = this.appState.websocketV2.getEventMarkets(elem.id);
                    return markets !== null && markets.length > 0 && elem.antePost;
                }
                return false;
            });
            if (events.length > 0) {
                tempCompetitionsWithAntePostEvent.push({
                    ...competition,
                    events,
                });
            }
        }

        return tempCompetitionsWithAntePostEvent.sort((a, b) => (a.name < b.name ? -1 : 1));
    }

    @action public onOpenCompetition = (competitionId: number): void => {
        if (this.activeCompetitionId === competitionId) {
            this.activeCompetitionId = null;
        } else {
            this.activeCompetitionId = competitionId;
        }
    };
}

export const AntePostListView = observer('AntePostListView', (props: PropsTypes) => {
    const appState = useAppStateContext();
    const [stateMap] = useState(() => new AutoMap<string, State>((sportId) => new State(appState, sportId)));
    const state = stateMap.get(props.sport);
    const { competitionsWithAntePostEvent, queryModel, activeCompetitionId, onOpenCompetition } = state;

    return (
        <div className='ante-post'>
            <header>
                <h2>Ante Post</h2>
            </header>

            {queryModel !== null && competitionsWithAntePostEvent.length === 0 ? (
                <span>No ante post events found</span>
            ) : null}

            {competitionsWithAntePostEvent.length > 0 ? (
                <ul>
                    {competitionsWithAntePostEvent.map((competition) => (
                        <AntePostCompetition
                            key={competition.id}
                            userId={props.userId}
                            activeCompetitionId={activeCompetitionId}
                            competition={competition}
                            onOpenCompetition={onOpenCompetition}
                        />
                    ))}
                </ul>
            ) : null}
            <Loading
                message='Loading...'
                active={queryModel === null}
            />
        </div>
    );
});
